import { Button, Input, Select } from "@arco-design/web-react";
import { RotateCcw, Search } from "lucide-react";

import { FULFILLMENT_STATUS_OPTIONS } from "../config";
import type { FulfillmentOrderListFilters } from "../types";
import "../../../shared/ui/crmListPageLayout.css";

type Props = {
  filters: FulfillmentOrderListFilters;
  onChange: (filters: FulfillmentOrderListFilters) => void;
  onSearch: () => void;
  onReset: () => void;
};

/** 确认件基础筛选区。 */
export function FulfillmentOrderFilterCard({ filters, onChange, onSearch, onReset }: Props) {
  return (
    <section
      className="crm-list-filter-panel"
      role="search"
      aria-label="确认件筛选"
      data-layout="two-tier-responsive"
    >
      <form
        className="crm-list-filter-fields"
        onSubmit={(event) => {
          event.preventDefault();
          onSearch();
        }}
      >
        <div className="crm-list-filter-primary">
          <label className="crm-list-field crm-list-field--lg">
            <span>关键词</span>
            <Input
              value={filters.q ?? ""}
              placeholder="课程线路标题"
              allowClear
              onPressEnter={onSearch}
              onChange={(q) => onChange({ ...filters, q })}
            />
          </label>
          <div className="crm-list-field crm-list-field--md">
            <span>状态</span>
            <Select
              value={filters.status ?? ""}
              placeholder="全部状态"
              allowClear
              getPopupContainer={() => document.body}
              options={FULFILLMENT_STATUS_OPTIONS.map((option) => ({ ...option }))}
              onChange={(status) => onChange({ ...filters, status: status || undefined })}
            />
          </div>
        </div>
      </form>
      <div className="crm-list-filter-actions">
        <Button icon={<RotateCcw size={16} />} onClick={onReset}>
          重置
        </Button>
        <Button type="primary" icon={<Search size={16} />} onClick={onSearch}>
          查询
        </Button>
      </div>
    </section>
  );
}
